import React, { createContext, useContext, useState, useEffect } from 'react';
import { subscribeToFeatureFlags } from '@config/features';

const FeatureFlagsContext = createContext({});

export const FeatureFlagsProvider = ({ children }) => {
  const [flags, setFlags] = useState({});

  useEffect(() => {
    const unsubscribe = subscribeToFeatureFlags((latestFlags) => {
      setFlags({ ...latestFlags });
    });
    return unsubscribe;
  }, []);

  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlags = () => useContext(FeatureFlagsContext);
